import getCollaborationLabel from './getCollaborationLabel'
import useProductCollaboration, { type UseProductCollaborationProps } from './useProductCollaboration'


type UseProductCollaborationLabelProps = UseProductCollaborationProps

const useProductCollaborationLabel = ({ labels }: UseProductCollaborationLabelProps ) => {
  const collaboration = useProductCollaboration({ labels })

  return getCollaborationLabel(collaboration)
}

export default useProductCollaborationLabel
